import { createSlice } from '@reduxjs/toolkit'
import { initialState } from './initialState.ts'

const calculatorSlice = createSlice({
  name: 'calculator',
  initialState: initialState,
  reducers: {
    openModal: (state) => {
      state.modalOpen = true
    },
    closeModal: (state) => {
      state.modalOpen = false
    }
  }
})

export const calculatorActions = calculatorSlice.actions
export const { reducer: calculatorReducer } = calculatorSlice
